// Landing Page Data
export const landingPageData = {
  coming_soon: "Coming Soon!",
  heading: "We have something big lined-up for August 9th 2025.",
  notify: {
    text: "Our next movie reveal.",
    button: "Notify Me",
    placeholder: "Enter Your Email Here...",
  },
};

// Social Media List
export const socialMediaData = [
  {
    icon: "fa-brands fa-x-twitter",
    link: "https://x.com/70mmEntertains",
    name: "X (Twitter)",
    class: "social-icons-twitter"
  },
  {
    icon: "fab fa-facebook",
    link: "https://www.facebook.com/70mmEntertainments",
    name: "Facebook",
    class: "social-icons-facebook",
  },
  {
    icon: "fab fa-instagram",
    link: "https://www.instagram.com/70mmentertains/#",
    name: "Instagram",
    class: "social-icons-instagram",
  },
  {
    icon: "fab fa-youtube",
    link: "https://www.youtube.com/70mmEntertainments",
    name: "YouTube",
    class: "social-icons-youtube",
  },
  {
    icon: "fab fa-linkedin-in",
    link: "https://www.linkedin.com/company/70mmentertainments/",
    name: "LinkedIn",
    class: "social-icons-linkedin",
  }

];

// About Us Data
export const aboutData = {
  desc: "We're a  film production house based in Hyderabad, founded in 2015 with a vision to make commercially successful movies and be a platform to enlighten creative talent of artists.",
  cards: [
    {
      icon: "far fa-thumbs-up",
      title: "Why Choose Us",
      desc: "Choose 70 mm for unmatched clarity, vibrant colors, and a truly immersive, cinematic experience you can feel—not just watch.",
    },
    {
      icon: "far fa-paper-plane",
      title: "Our Mission",
      desc: "Our goal is to create commercially successful movies with compelling and engaging storylines.",
    },
    {
      icon: "far fa-eye",
      title: "Our Vision",
      desc: "To preserve the magic of cinema by combining timeless storytelling with the grandeur of 70mm film for future generations.",
    },
  ],
  projects_title: "Some of our most recent projects.",
  projects: [
    {
      title: "Sridevi Soda Center",
      category: "Movie",
      img: "images/sridevi-soda-center_1500x999.jpg",
    },
    {
      title: "Yatra",
      category: "Movie",
      img: "images/Yatra_1500x999.jpg",
    },
    {
      title: "Anando Brahma",
      category: "Movie",
      img: "images/anando-brahma-0_1500x999.jpg",
    },
    {
      title: "Bhale Manchi Roju",
      category: "Movie",
      img: "images/slider-13_1500x999.jpg",
    }
  ],
  get_in_touch: "Get in touch with us",
};

// Contact Us data
export const contactData = {
  desc: "We launch our new website soon. For Customer Support and Query, Get in touch with us.",
  support_note: "For Customer Support, Send us a note.",
  cards: [
    {
      icon: "fas fa-map-marker-alt",
      title: "VISIT US",
      lines: ["70mm Entertainments",
        "Pragathi Plaza",
        "Plot no 741, Road no 39, 5th floor, Ayyappa society, Madhapur Hyderabad 500081"],
    },
    {
      icon: "fas fa-envelope",
      title: "INQUIRIES",
      lines: ["contact@70mmentertainments.com"],
    },
    {
      icon: "fas fa-clock",
      title: "BUSINESS HOURS",
      lines: ["Mon to Fri", "(10 am – 8 pm)"],
    },
  ],

  form: {
    nameLable: "What is Your Name:",
    namePlaceholder: "Enter Your Name",

    emailLable: "Your Email Address:",
    emailPlaceholder: "Enter Your Email",

    messageLable: "How can I Help you?",
    messagePlaceholder: "Enter Your Query",

    submitButton: "Send Message",
  }
};
